<script lang="ts">
    import { onMount } from "svelte";
    import { getEntries, Shortcut } from "@ceyper-common";
    import { Search as GlobalSearch } from "svelte-editor-layout";
    import { COMMANDS } from "$lib/commands";
    import Icon from "$lib/utility/Icon.svelte";

    let searchOpen = false;

    onMount(() =>
        COMMANDS.registerAction(
            "general.search",
            () => {
                searchOpen = true;
            },
            "all",
        ),
    );

    const commands = getEntries(COMMANDS.commands)
        .map(([key, value]) => {
            return {
                name: value.group ? value.group + " | " + value.name : value.name,
                action: value.invoke,
                command: value,
                enabled: value.enabled,
            };
        })
        .filter((cmd) => cmd.command.searchable ?? true);

    const tabs = [
        {
            name: "Commands",
            items: commands,
        },
    ];

    function split(fullName: string) {
        let result = fullName.split("|");
        if (result.length === 1) {
            return [undefined, result[0]];
        } else {
            return result;
        }
    }
</script>

<GlobalSearch bind:open={searchOpen} items={commands}>
    {#snippet item({ item, match })}
        {@const [group, name] = split(match)}
        <div>
            {#if group}
                <span>{@html group}</span>
                <Icon id="chevron-right-16" />
            {/if}
            <span>{@html name}</span>
            <Shortcut command={item.command} />
        </div>
    {/snippet}
</GlobalSearch>

<style>
    div {
        display: flex;
        align-items: center;
        height: 100%;

        & :global(kbd:first-of-type) {
            margin-left: 0.5em;
        }

        & > :global(.icon) {
            color: var(--t400);
            /*font-size*/
        }
    }



    span {
        & > :global(b) {
            font-weight: unset;
            color: var(--tacc);
        }
    }
</style>
